import React, { useState, useEffect } from "react";
import { Autocomplete, TextField } from "@mui/material";
import './autocomplete.scss'

const InputAutoComplete = (props) => {
    const [inputValue, setInputValue] = useState('');
    return (
        <Autocomplete
            className={props.className}
            options={inputValue.length < 2 ? [] : props.options} // No mostrar opciones si no hay texto
            getOptionLabel={props.getOptionLabel}
            renderOption={props.getOptionKey ? (optionProps, option) => {
                const listItemProps = { ...optionProps };
                delete listItemProps.key;
                return (
                    <li {...listItemProps} key={props.getOptionKey(option)}>
                        {props.getOptionLabel(option)}
                    </li>
                );
            } : undefined}
            value={props.value}
            onChange={props.onChange}
            isOptionEqualToValue={props.isOptionEqualToValue}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
            renderInput={(params) => (
                <TextField {...params} label={props.placeholder} variant="outlined" />
            )}
            sx={{ width: 270 }}
            disabled={props.disabled}
            slotProps={{
                popper: {
                    sx: { zIndex: 99999 }
                }
            }}
        />
    );

}
export default InputAutoComplete;
